import { GeneralSettingsConstants } from 'modules/application/detail/attendance/generalsettings/GeneralSettingsConstants';
export class CallsService {
    static $inject = ['BlipService'];
    constructor(BlipService) {
        this.BlipService = BlipService;
        this.CALLS_MEDIA_MESSAGE_TYPE = 'application/vnd.iris.calls.media+json';
        this.onAsyncFetchSession = (ownerIdentity) => {
            return async (sessionId) => {
                if (!sessionId) {
                    return undefined;
                }
                const session = await this.getSessionById(ownerIdentity, sessionId);
                return session;
            };
        };
        this.getSessionById = async (ownerIdentity, sessionId) => {
            try {
                const command = await this.BlipService.processCommand({
                    method: 'get',
                    to: GeneralSettingsConstants.POSTMASTER,
                    uri: `lime://${ownerIdentity}/calls/session/${sessionId}`,
                });
                return command.resource;
            }
            catch (e) {
                console.error('[BlipCalls] getSession error: ', e);
                throw e;
            }
        };
    }
}
CallsService.$inject = ['BlipService'];
